import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ProjectVersionsNativeStatusComponent extends Component {
  @service platform;
}
